import convert from 'heic-convert/browser';

export const convertHeicToJpg = async (file: File, quality = 1) => {
  if (!file || !['image/heif', 'image/heic', ''].includes(file.type)) {
    throw new Error('Invalid HEIC file');
  }

  try {
    const arrayBuffer = await file.arrayBuffer();
    const buffer = new Uint8Array(arrayBuffer);

    const outputBuffer = await convert({
      buffer,
      format: 'JPEG',
      quality,
    });

    const fileNameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.'));
    // convert() returns a Uint8Array whose backing store is only known to be
    // ArrayBufferLike, which is not a valid BlobPart. Copy into a view over a
    // definite ArrayBuffer so File accepts it without a cast.
    const jpegBytes = new Uint8Array(outputBuffer.byteLength);
    jpegBytes.set(outputBuffer);
    const convertedFile = new File([jpegBytes], `${fileNameWithoutExtension}.jpg`, {
      type: 'image/jpeg',
    });

    return convertedFile;
  } catch {
    throw new Error('Error converting HEIC to JPG');
  }
};
